import { countAndMapAssignedTasks } from "./commonUtils";
import { MemberTaskCount } from "../../types";
import axios from "axios";
import { EscrowLedger } from "../../escrowLedgers/types";
import dayjs from "dayjs";

export const searchEscrowOverdueOrders = async (): Promise<EscrowLedger[]> => {
  const { data } = await axios.get<EscrowLedger[]>(`/api/ledgers/getescrowledgers`);
  const endDate = dayjs().add(1, "day");
  return data.filter((d) => {
    const dueDate = dayjs(d.dueDate);
    return (d.amount && d.dueDate && dueDate.isBefore(endDate, "day")) || (d.amount && !d.dueDate);
  });
};

export const getEscrowOverdueOrdersUniqueAssignedToList = (escrowOverdueOrders: EscrowLedger[]): MemberTaskCount[] =>
  countAndMapAssignedTasks(escrowOverdueOrders, "Escrow Overdue Orders");
